"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Try to log an error to the supported error reporting libraries.
 *
 * We hope to find an error reporting client available globally,
 * but if not we will simple console.log
 *
 * @param {Error, string} ex - Preferably an Error object that Raven can extract a stacktrace from,
 *      but a string or any other object that can be transformed to a string by Raven works.
 * @param {object} [context] - (optional) An object containing additional data related to the error
 *      that we'd like to pass onto Sentry if possible.
 * @param {array} fingerprint - (optional) An array of tags to use as a unique fingerprint for
 *      which Sentry should group errors by.
 */
var logError = function logError(error, context, fingerprint) {
  if (typeof window === 'undefined') {
    return;
  }

  if (window.newrelic) {
    window.newrelic.noticeError(error);
  }

  if (window.Raven) {
    window.Raven.captureException(error, {
      fingerprint: fingerprint ? ['{{ default }}'] + fingerprint : undefined,
      extra: context
    });
  }
  /* eslint no-console: 0 */

  /* eslint no-unused-expressions: 0 */


  window.console && window.console.error && window.console.error(error);
};

var _default = logError;
exports.default = _default;